var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78781 7.54407L1.92106 13.7746C1.63811 14.0751 1.17938 14.0751 0.896463 13.7746L0.212203 13.0479C-0.0702608 12.748 -0.0708044 12.2618 0.210996 11.9611L4.8605 6.99998L0.210995 2.03892C-0.0708049 1.73823 -0.0702612 1.25205 0.212203 0.952065L0.896462 0.225371C1.17941 -0.0751229 1.63814 -0.0751229 1.92106 0.225371L7.78781 6.4559C8.07073 6.75639 8.07073 7.24357 7.78781 7.54407Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.659d02e2c00ea12e1b89bdfb9fbb87fa.svg";
export { ForwardRef as ReactComponent };